import CardLoader from "./card-loader.component";

export default CardLoader;
